import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TransliterateService {
  private apiUrl = 'https://stories.funtelstudio.com/storyapi/transliterate.php';
  private cache: Record<string, any> = {};
  private transliterationEnabled = new BehaviorSubject<boolean>(false);
  private currentLanguage = new BehaviorSubject<string>('en');

  constructor(private http: HttpClient) {}
transliterateWord(text: string, lang: string = 'hi'): Observable<string> {
  return this.transliterateText(text, lang).pipe(
    map(result => result.transliterated)
  );
}
  // Enhanced transliteration with better error handling
  transliterateText(text: string, lang: string): Observable<any> {
    if (!text.trim() || lang === 'en') {
      return of({ 
        success: true, 
        transliterated: text, 
        suggestions: [] 
      });
    }

    const cacheKey = `${lang}:${text}`;
    if (this.cache[cacheKey]) {
      return of(this.cache[cacheKey]);
    }

    console.log('Sending transliteration request:', { text, lang });

    return this.http.post(this.apiUrl, { text, lang }).pipe(
      timeout(5000),
      map((response: any) => {
        console.log('Transliteration API response:', response);
        
        if (response && response.success) {
          this.cache[cacheKey] = response;
          return response;
        } else {
          return {
            success: false,
            transliterated: text,
            suggestions: []
          };
        }
      }),
      catchError((error) => {
        console.error('Transliteration API error:', error);
        return of({
          success: false,
          transliterated: text,
          suggestions: []
        });
      })
    );
  }

  setTransliteration(enabled: boolean): void {
    this.transliterationEnabled.next(enabled);
  }

  setLanguage(lang: string): void {
    this.currentLanguage.next(lang);
    this.clearCache();
  }

  getTransliterationStatus(): Observable<boolean> {
    return this.transliterationEnabled.asObservable();
  }

  getCurrentLanguage(): Observable<string> {
    return this.currentLanguage.asObservable();
  }

  clearCache(): void {
    this.cache = {};
  }
}